var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "@rentiohq/web-theme";
export var CameraButton = styled.button(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  cursor: pointer;\n  background: #eee;\n  padding: 8px;\n  border-radius: 50%;\n\n  &:hover {\n    background: #e2dddd;\n  }\n"], ["\n  cursor: pointer;\n  background: #eee;\n  padding: 8px;\n  border-radius: 50%;\n\n  &:hover {\n    background: #e2dddd;\n  }\n"])));
var templateObject_1;
